import { createContext, useContext, type ReactNode } from 'react';

import type { Device } from '@web-platform/shared-travel-tools-types/src/context';

export const DeviceContext = createContext<Device | null>(null);

type Props = {
  children: ReactNode;
  value: Device;
};

export const DeviceProvider = ({ children, value }: Props) => (
  <DeviceContext.Provider value={value}>{children}</DeviceContext.Provider>
);

export const useDevice = (): Device => {
  const ctx = useContext(DeviceContext);
  if (!ctx) throw new Error('useDevice must be used within DeviceProvider');
  return ctx;
};
